import React, { useEffect, useState } from "react";
import { PCNavListItemType } from "../../../utils/projectUtils";
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from "@patternfly/react-icons";
import { JumpLinks, JumpLinksItem } from "@patternfly/react-core";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import "./ProjectDetailsSidenav.scss";
import { getProjectChecklist } from "../../../api/pfs";
import { useParams } from "react-router";
import { CWRouteParams } from "../../../constants/router";
// import { sendEvent } from '@rhc-shared-components/rhc-eddl';
// import Env from '../../../utils/env';
// import Uri from 'jsuri';

interface NavigationIconProps {
  iconStatus: string
}
enum IconStatus {
  INCOMPLETE_REQUIRED_FIELDS = 'INCOMPLETE_REQUIRED_FIELDS',
  INCOMPLETE_NON_REQUIRED_FIELDS = 'INCOMPLETE_NON_REQUIRED_FIELDS',
  COMPLETE_FIELDS = 'COMPLETE_FIELDS'
}
const NavigationIcon: React.FC<NavigationIconProps> = (props: NavigationIconProps) => {
  switch (props.iconStatus as IconStatus) {
    case IconStatus.INCOMPLETE_REQUIRED_FIELDS:
      return <ExclamationCircleIcon color="#C9190B" />
    case IconStatus.INCOMPLETE_NON_REQUIRED_FIELDS:
      return <ExclamationTriangleIcon />
    case IconStatus.COMPLETE_FIELDS:
      return <CheckCircleIcon />
    default: return <></>
  }
}

interface SidenavListItem extends PCNavListItemType {
  validationStatus?: IconStatus
}
const ProjectDetailsSidenav: React.FC<{
  navList: PCNavListItemType[]
}> = ({navList}) => {
  const history = useHistory();
  const params = useParams<CWRouteParams>()
  const { data: checklistStats } = useQuery(['projectChecklist'], ({signal}) => getProjectChecklist(params.id, signal));
  const [sidenavList, setSideNavList] = useState<SidenavListItem[]>();
  useEffect(() => {
    let newNavList  = navList as SidenavListItem[];
    checklistStats?.items?.forEach((item) => {
      item?.checklistItems?.forEach((checklist) => {
        newNavList = newNavList.map((nav) => {
          if (checklist.name.endsWith(nav.postFixName)) {
            nav.validationStatus = checklist.status === "COMPLETED" ?
              IconStatus.COMPLETE_FIELDS :
              (checklist.optional ? IconStatus.INCOMPLETE_NON_REQUIRED_FIELDS :
                IconStatus.INCOMPLETE_REQUIRED_FIELDS);
          }
          return nav;
        })
      });
    });
    setSideNavList(newNavList);
  }, [navList, checklistStats]);

  return (<JumpLinks
    isVertical
    className="project-detail-sidenav"
  >
    {sidenavList?.map(({path, validationStatus, text}, index) => (
      <JumpLinksItem
        key={index}
        // data-analytics-track-by-analytics-manager="false"
        onClick={() => {
          // sendEvent({
          //   event: 'Tab link clicked',
          //   linkInfo: {
          //     href: new Uri(Env.ConnectPortalUrls[Env.getEnvName()]).setPath(path).toString(),
          //     targetHost: 'connect.redhat.com',
          //     text: { text },
          //   },
          // });
          history.push(path)
        }}
        isActive={window.location.pathname.includes(path)}
      >
        <div className="project-detail-sidenav__wrapper">
          <div className="project-detail-sidenav__wrapper__child">
            {validationStatus && <NavigationIcon iconStatus={validationStatus} />}
          </div>
          {`${text}`}
        </div>
      </JumpLinksItem>))}
  </JumpLinks>)
};
export default ProjectDetailsSidenav;
